import responsiveRing from './geometry';

const preRenderResponsive = [{ name: 'responsiveRing', method: responsiveRing }];

const afterRenderResponsive = [];

export default {
  preRender: preRenderResponsive,
};
